module.exports = __webpack_public_path__ + "img/EE11534064.a84c986a.png";